import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Inventory from '../views/inventory/Inventory.vue'
import Product from '../views/product/Product.vue'
import Supplier from '../views/supplier/Supplier.vue'
import Client from '../views/client/Client.vue'
import Quote from '../views/quote/Quote.vue'
import Category from '../views/category/Category.vue'
import Settings from '../views/setting/Settings.vue'
import Order from '../views/order/Order.vue'
import Invoice from '../views/invoice/Invoice.vue'
import Process from '../views/process/Process.vue'
import Purchase from '../views/purchase/Purchase.vue'
import User from '../views/user/User.vue'
import Login from '../views/Login.vue'
import SignUp from '../views/Signup'
import LandingPage from '../views/LandingPage.vue'
import Analytics from '../views/Analytics'
import Delivery from '../views/delivery/Delivery'
import Return from '../views/return/Return'
import Payment from '../views/payment/Payment'
import Reception from '../views/reception/Reception'
import ClientDetails from '../views/client/ClientDetails'
import SupplierDetails from '../views/supplier/SupplierDetails'
import OrderDetails from '../views/order/OrderDetails'
import InvoiceDetails from '../views/invoice/InvoiceDetails'
import DeliveryDetails from '../views/delivery/DeliveryDetails'
import QuoteDetails from '../views/quote/QuoteDetails'
import PurchaseDetails from '../views/purchase/PurchaseDetails'
import ReceptionDetails from '../views/reception/ReceptionDetails'
import InventoryDetails from '../views/inventory/InventoryDetails'
import ProductDetails from '../views/product/ProductDetails'
import PaymentDetails from '../views/payment/PaymentDetails'
import CreditInvoice from '../views/credit-invoice/CreditInvoice'
import SupplierInvoice from '../views/supplier-invoice/Invoice'
import SupplierInvoiceDetails from '../views/supplier-invoice/InvoiceDetails'
import SupplierReturn from '../views/supplier-return/Return'
import SupplierReturnDetails from '../views/supplier-return/ReturnDetails'
import CreditInvoiceDetails from '../views/credit-invoice/CreditInvoiceDetails'
import ReturnDetails from '../views/return/ReturnDetails'
import Logs from '../views/Log'
import Logout from '../views/Logout'
import FiveHundered from '../views/500'
import ResetPassword from '../views/ResetPassword'
import newPassword from '../views/NewPassword'
import Subscribe from '../views/Subscribe'
import UserDetails from '../views/user/UserDetails'
import Attachment from '../views/attachment/Attachment.vue'
import Pos from '../views/pos/Pos.vue'
import PosTransactions from '../views/pos/PosTransactions.vue'
import CashRegisters from '@/views/pos/CashRegisters.vue'
import Onboarding from '@/views/onboarding/Onboarding.vue'
import PosCashRegisterDetails from '../views/pos/PosCashRegisterDetails.vue'
import PosInsight from '../views/pos/PosInsights.vue'
import Warehouse from '../views/warehouse/Warehouse.vue'
import WarehouseDetails from '../views/warehouse/WarehouseDetails.vue'
import CategoryDetails from '../views/category/CategoryDetails.vue'
import ExternalDocument from '../components/invoiceLayout/ExternalInvoiceTemplate'
import Plans from '@/views/Plans.vue'
import Subscriptions from '@/views/Subscriptions.vue'
import SubscriptionDetails from '@/views/SubscriptionDetails.vue'
import Attendance from '@/views/Attendance.vue'
import SubscriptionOverview from '@/views/SubscriptionOverview.vue'
import ExternalAttendance from '@/views/ExternalAttendance.vue'
import ReservationInsights from '@/views/ReservationInsights.vue'
import Accountant from '@/views/Accountant.vue'
import SalesInsights from '@/views/sales/SalesInsights.vue'
import PurchaseInsights from '@/views/purchase/PurchaseInsights.vue'
import Project from '@/views/project/Project.vue'
import ProjectDetails from '@/views/project/ProjectDetails.vue'
import MyTasks from '@/views/task/MyTasks.vue'
import BankAccount from '@/views/bank-account/BankAccount.vue'
import BankAccountDetails from '@/views/bank-account/BankAccountDetails.vue'
import Employee from '@/views/hr/Employee.vue'
import EmployeeDetails from '@/views/hr/EmployeeDetails.vue'
import HrInsights from '@/views/hr/HrInsights.vue'
import HrHolidays from '@/views/hr/Holidays.vue'
import HrPayroll from '@/views/hr/Payroll.vue'
import PayrollDetails from '@/views/hr/PayrollDetails.vue'
import HrAttendance from '@/views/hr/Attendance.vue'
import Support from '@/views/Support.vue'
import Tutorials from '@/views/Tutorials.vue'
import Contract from '@/views/contract/Contract.vue'
import ContractDetails from '@/views/contract/ContractDetails.vue'
import TwoFactorAuth from '../views/TwoFactorAuth.vue'
import GstockyAI from '@/views/ai/GstockyAI.vue'
import Lead from '@/views/lead/Lead.vue'
import LeadDetails from '@/views/lead/LeadDetails.vue'
import PlanningList from '@/views/planning/PlanningList.vue'
import MyPlanning from '@/views/planning/MyPlanning.vue'
import PlanningDetails from '@/views/planning/PlanningDetails.vue'
import Zakat from '@/views/Zakat.vue'
import Importer from '@/views/Importer.vue'
import Marketing from '@/views/marketing/Marketing.vue'
import MarketingSegments from '@/views/marketing/MarketingSegments.vue'
import CampaignBuilder from '@/views/marketing/CampaignBuilder.vue'
import CampaignReport from '@/views/marketing/CampaignReport.vue'
import OAuthAuthorize from '@/views/OAuthAuthorize.vue'

import AdminLogin from '../views/admin/AdminLogin.vue'
import AdminLayout from '../views/admin/AdminLayout.vue'
import AdminDashboard from '../views/admin/AdminDashboard.vue'
import AdminAccounts from '../views/admin/AdminAccounts.vue'
import AdminAccountDetails from '../views/admin/AdminAccountDetails.vue'
// import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/oauth/authorize',
    name: 'OAuthAuthorize',
    component: OAuthAuthorize,
    meta: { requiresAuth: true, sidebar: false }
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: Onboarding,
    meta: { requiresAuth: true, sidebar: false }
  },
  {
    path: '/',
    name: 'Home',
    component: Dashboard
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: Subscribe
  },
  {
    path: '/inventories',
    name: 'Inventory',
    component: Inventory
  },
  {
    path: '/products',
    name: 'Product',
    component: Product
  },
  {
    path: '/clients',
    name: 'Client',
    component: Client
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Project
  },
  {
    path: '/projects/:id',
    name: 'ProjectDetails',
    component: ProjectDetails,
    params: true
  },
  {
    path: '/tasks',
    name: 'MyTasks',
    component: MyTasks,
    meta: {
      requiresAuth: true,
      title: 'My Tasks'
    }
  },
  {
    path: '/plannings',
    name: 'PlanningList',
    component: PlanningList,
    meta: { requiresAuth: true }
  },
  {
    path: '/plannings/:id',
    name: 'PlanningDetails',
    component: PlanningDetails,
    params: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-planning',
    name: 'MyPlanning',
    component: MyPlanning,
    meta: { requiresAuth: true }
  },
  {
    path: '/suppliers',
    name: 'Supplier',
    component: Supplier
  },
  {
    path: '/quotes',
    name: 'Quote',
    component: Quote
  },
  {
    path: '/categories',
    name: 'Category',
    component: Category
  },
  {
    path: '/categories/:id',
    name: 'CategoryDetails',
    component: CategoryDetails,
    params: true
  },
  {
    path: '/warehouses',
    name: 'Warehouse',
    component: Warehouse
  },
  {
    path: '/warehouses/:id',
    name: 'warehousesDetails',
    component: WarehouseDetails,
    params: true
  },
  {
    path: '/settings/:tab?',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/importer',
    name: 'Importer',
    component: Importer
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Order
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: Invoice
  },
  {
    path: '/receipts',
    name: 'Receipts',
    component: Process
  },
  {
    path: '/processes',
    redirect: '/receipts'
  },
  {
    path: '/pos',
    name: 'Pos',
    component: Pos,
    meta: { sidebar: true }
  },
  {
    path: '/pos-insights',
    name: 'PosInsight',
    component: PosInsight,
    meta: { sidebar: true }
  },
  {
    path: '/pos-transactions',
    name: 'PosTransactions',
    component: PosTransactions,
    meta: { sidebar: true }
  },
  {
    path: '/pos-cash-registers',
    name: 'CashRegisters',
    component: CashRegisters
  },
  {
    path: '/pos-transactions/:id',
    name: 'PosTransactionDetails',
    params: true,
    component: () => import('../views/pos/PosTransactionDetails.vue')
  },
  {
    path: '/pos-cash-registers/:id',
    name: 'PosCashRegisterDetails',
    params: true,
    component: PosCashRegisterDetails
  },
  {
    path: '/supplier-invoices',
    name: 'SupplierInvoices',
    component: SupplierInvoice,
  },
  {
    path: '/supplier-invoices/:id',
    name: 'SupplierInvoiceDetails',
    component: SupplierInvoiceDetails,
    params: true
  },
  {
    path: '/supplier-returns',
    name: 'SupplierReturn',
    component: SupplierReturn,
  },
  {
    path: '/supplier-returns/:id',
    name: 'SupplierReturnDetails',
    component: SupplierReturnDetails,
    params: true
  },
  {
    path: '/credit-invoices',
    name: 'CreditInvoices',
    component: CreditInvoice
  },
  {
    path: '/deliveries',
    name: 'Deliveries',
    component: Delivery
  },
  {
    path: '/returns',
    name: 'Returns',
    component: Return
  },
  {
    path: '/purchases',
    name: 'Purchase',
    component: Purchase
  },
  {
    path: '/payments',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/receptions',
    name: 'Reception',
    component: Reception
  },
  {
    path: '/users',
    name: 'User',
    component: User
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics
  },
  {
    path: '/attachments',
    name: 'attachments',
    component: Attachment
  },
  {
    path: '/clients/:id',
    name: 'ClientDetails',
    component: ClientDetails,
    params: true
  },
  {
    path: '/suppliers/:id',
    name: 'SupplierDetails',
    component: SupplierDetails,
    params: true
  },
  {
    path: '/orders/:id',
    name: 'OrderDetails',
    component: OrderDetails,
    params: true
  },
  {
    path: '/invoices/:id',
    name: 'InvoiceDetails',
    component: InvoiceDetails,
    params: true
  },
  {
    path: '/credit-invoices/:id',
    name: 'CreditInvoiceDetails',
    component: CreditInvoiceDetails,
    params: true
  },
  {
    path: '/deliveries/:id',
    name: 'DeliveryDetails',
    component: DeliveryDetails,
    params: true
  },
  {
    path: '/returns/:id',
    name: 'ReturnDetails',
    component: ReturnDetails,
    params: true
  },
  {
    path: '/quotes/:id',
    name: 'QuoteDetails',
    component: QuoteDetails,
    params: true
  },
  {
    path: '/purchases/:id',
    name: 'PurchaseDetails',
    component: PurchaseDetails,
    params: true
  },
  {
    path: '/inventories/:id',
    name: 'InventoryDetails',
    component: InventoryDetails,
    params: true
  },
  {
    path: '/receptions/:id',
    name: 'ReceptionDetails',
    component: ReceptionDetails,
    params: true
  },
  {
    path: '/payments/:id',
    name: 'PaymentDetails',
    component: PaymentDetails,
    params: true
  },
  {
    path: '/products/:id',
    name: 'ProductDetails',
    component: ProductDetails,
    params: true
  },
  {
    path: '/users/:id',
    name: 'UserDetails',
    component: UserDetails,
    params: true
  },
  {
    path: '/logs',
    name: 'Logs',
    component: Logs,
    params: true
  },
  {
    path: '/lp',
    name: 'LandingPage',
    component: LandingPage,
    meta: { sidebar: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { sidebar: false }
  },
  {
    path: '/2fa',
    name: 'TwoFactorAuth',
    component: TwoFactorAuth,
    meta: { sidebar: false }
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
    meta: { sidebar: false }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: { sidebar: false }
  },
  {
    path: '/500',
    name: '500',
    component: FiveHundered,
    meta: { sidebar: false }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { sidebar: false }
  },
  {
    path: '/new-password',
    name: 'newPassword',
    component: newPassword,
    meta: { sidebar: false }
  },
  {
    path: '/documents/:id',
    params: true,
    name: 'Document',
    component: ExternalDocument,
    meta: { sidebar: false }
  },
  {
    path: '/d/:id',
    params: true,
    name: 'Document',
    component: ExternalDocument,
    meta: { sidebar: false }
  },
  {
    path: '/mcp-preview/:id',
    params: true,
    name: 'McpDocumentPreview',
    component: ExternalDocument,
    meta: { sidebar: false }
  },
  {
    path: '/plans',
    name: 'Plans',
    component: Plans,
    meta: {
      requiresAuth: true,
      title: 'Subscription Plans'
    }
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    component: Subscriptions,
    meta: {
      requiresAuth: true,
      title: 'Client Subscriptions'
    }
  },
  {
    path: '/subscriptions/:id',
    name: 'SubscriptionDetails',
    component: SubscriptionDetails,
    meta: {
      requiresAuth: true,
      title: 'Subscription Details'
    }
  },
  {
    path: '/attendance',
    name: 'Attendance',
    component: Attendance,
    meta: {
      requiresAuth: true,
      title: 'Attendance Management'
    }
  },
  {
    path: '/subscription-overview',
    name: 'SubscriptionOverview',
    component: SubscriptionOverview,
    meta: {
      requiresAuth: true,
      title: 'Subscription Overview'
    }
  },
  {
    path: '/external-attendance',
    name: 'ExternalAttendance',
    component: ExternalAttendance,
    meta: {
      title: 'External Attendance',
      sidebar: false
    }
  },
  {
    path: '/reservations',
    name: 'Reservations',
    component: () => import('../views/Reservations.vue')
  },
  {
    path: '/reservation-insights',
    name: 'ReservationInsights',
    component: ReservationInsights,
    meta: {
      requiresAuth: true,
      title: 'Reservation Insights'
    }
  },
  {
    path: '/sales-insights',
    name: 'SalesInsights',
    component: SalesInsights,
    meta: {
      requiresAuth: true,
      title: 'Sales Insights'
    }
  },
  {
    path: '/purchase-insights',
    name: 'PurchaseInsights',
    component: PurchaseInsights,
    meta: {
      requiresAuth: true,
      title: 'Purchase Insights'
    }
  },
  {
    path: '/accountants',
    name: 'Accountant',
    component: Accountant
  },
  {
    path: '/bank-accounts',
    name: 'BankAccount',
    component: BankAccount
  },
  {
    path: '/bank-accounts/:id',
    name: 'BankAccountDetails',
    component: BankAccountDetails,
    params: true
  },
  {
    path: '/hr/my-space',
    name: 'MySpace',
    component: () => import('../views/hr/MySpace.vue'),
    meta: {
      requiresAuth: true,
      title: 'My Space'
    }
  },
  {
    path: '/hr/employees',
    name: 'Employees',
    component: Employee
  },
  {
    path: '/hr/employees/:id',
    name: 'EmployeeDetails',
    component: EmployeeDetails,
    params: true
  },
  {
    path: '/hr/insights',
    name: 'HrInsights',
    component: HrInsights
  },
  {
    path: '/hr/leaves',
    name: 'HrLeaves',
    component: HrHolidays,
    meta: {
      requiresAuth: true,
      title: 'Employee Leaves'
    }
  },
  {
    path: '/hr/attendance',
    name: 'HrAttendance',
    component: HrAttendance,
    meta: {
      requiresAuth: true,
      title: 'Attendance Management'
    }
  },
  {
    path: '/hr/payroll',
    name: 'HrPayroll',
    component: HrPayroll,
    meta: {
      requiresAuth: true,
      title: 'Payroll Management'
    }
  },
  {
    path: '/hr/payroll/:id',
    name: 'PayrollDetails',
    component: PayrollDetails,
    meta: {
      requiresAuth: true,
      title: 'Payroll Details'
    }
  },
  {
    path: '/support',
    name: 'Support',
    component: Support,
    meta: {
      requiresAuth: true,
      title: 'Support'
    }
  },
  {
    path: '/tutorials',
    name: 'Tutorials',
    component: Tutorials,
    meta: {
      requiresAuth: true,
      title: 'Tutorials'
    }
  },
  {
    path: '/advanced-insights',
    name: 'AdvancedInsights',
    component: () => import('../views/AdvancedInsights.vue'),
    meta: {
      requiresAuth: true,
      title: 'Advanced Insights'
    }
  },
  {
    path: '/contracts',
    name: 'Contracts',
    component: Contract,
    meta: {
      requiresAuth: true,
      title: 'Contracts'
    }
  },
  {
    path: '/contracts/:id',
    name: 'ContractDetails',
    component: ContractDetails,
    meta: {
      requiresAuth: true,
      title: 'Contract Details'
    }
  },
  {
    path: '/ai',
    name: 'GstockyAI',
    component: GstockyAI,
    meta: {
      requiresAuth: true,
      title: 'Gstocky AI'
    }
  },
  {
    path: '/leads',
    name: 'Leads',
    component: Lead,
    meta: {
      requiresAuth: true,
      title: 'Leads'
    }
  },
  {
    path: '/leads/:id',
    name: 'LeadDetails',
    component: LeadDetails,
    meta: {
      requiresAuth: true,
      title: 'Lead Details'
    }
  },
  {
    path: '/marketing',
    redirect: '/marketing/campaigns'
  },
  {
    path: '/marketing/campaigns',
    name: 'MarketingCampaigns',
    component: Marketing,
    meta: {
      requiresAuth: true,
      title: 'Marketing Campaigns'
    }
  },
  {
    path: '/marketing/campaigns/new',
    name: 'NewMarketingCampaign',
    component: CampaignBuilder,
    meta: {
      requiresAuth: true,
      title: 'New Marketing Campaign'
    }
  },
  {
    path: '/marketing/campaigns/:id/report',
    name: 'MarketingCampaignReport',
    component: CampaignReport,
    meta: {
      requiresAuth: true,
      title: 'Marketing Campaign Report'
    }
  },
  {
    path: '/marketing/campaigns/:id/edit',
    name: 'EditMarketingCampaign',
    component: CampaignBuilder,
    meta: {
      requiresAuth: true,
      title: 'Edit Marketing Campaign'
    }
  },
  {
    path: '/marketing/segments',
    name: 'MarketingSegments',
    component: MarketingSegments,
    meta: {
      requiresAuth: true,
      title: 'Marketing Segments'
    }
  },
  {
    path: '/zakat',
    name: 'Zakat',
    component: Zakat,
    meta: {
      requiresAuth: true,
      title: 'Zakat Calculator'
    }
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { title: 'Admin Login', sidebar: false }
  },
  {
    path: '/admin',
    redirect: '/admin/dashboard'
  },
  {
    path: '/admin',
    component: AdminLayout,
    children: [
      { path: 'dashboard', name: 'AdminDashboard', component: AdminDashboard, meta: { title: 'Admin Dashboard', sidebar: false, isAdmin: true } },
      { path: 'accounts', name: 'AdminAccounts', component: AdminAccounts, meta: { title: 'Admin Accounts', sidebar: false, isAdmin: true } },
      { path: 'accounts/:id', name: 'AdminAccountDetails', component: AdminAccountDetails, meta: { title: 'Account Details', sidebar: false, isAdmin: true } },
      { path: 'licenses', name: 'AdminLicenses', component: () => import('../views/admin/AdminLicenses.vue'), meta: { title: 'Licenses', sidebar: false, isAdmin: true } },
      { path: 'announcements', name: 'AdminAnnouncements', component: () => import('../views/admin/AdminAnnouncements.vue'), meta: { title: 'Announcements', sidebar: false, isAdmin: true } }
    ]
  },
  { path: '*', redirect: '/' },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active"
})

router.beforeEach((to, from, next) => {
  // Public routes that don't require authentication
  const publicRoutes = ['/login', '/signup', '/reset-password', '/new-password', '/lp', '/2fa']
  const isPublicRoute = publicRoutes.includes(to.path) || to.path.startsWith('/documents/') || to.path.startsWith('/d/') || to.path.startsWith('/mcp-preview/') || to.path.startsWith('/admin')

  // Check for token before loading protected routes
  const token = localStorage.getItem('access_token')

  // If no token and trying to access a protected route, redirect to login
  if (!token && !isPublicRoute && to.path !== '/external-attendance' && !(to.query && to.query.at)) {
    if (to.path === '/oauth/authorize') sessionStorage.setItem('post_login_redirect', to.fullPath)
    return next({ path: '/login' })
  }

  // Capture referral code (?ref=...) -> set cookie and redirect to /login
  // BUT: skip this logic if we're on /lp with a lang parameter
  if (to.query && to.query.ref) {
    try {
      const ref = String(to.query.ref)
      const days = 30
      const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
      localStorage.setItem('affiliate_ref', ref)
      document.cookie = `affiliate_ref=${encodeURIComponent(ref)}; expires=${expires}; path=/; domain=.gstocky.com; SameSite=Lax`
    } catch (e) { /* ignore */ }
    // Avoid redirect loop if already on /login
    if (to.path !== '/login') {
      return next({ path: '/login' })
    }
  }

  if (to.query && to.query.affiliate_id) {
    try {
      const ref = String(to.query.affiliate_id)
      localStorage.setItem('account_manager_id', ref)
    } catch (e) { /* ignore */ }
  }

  // Allow landing page with lang query parameter
  if (to.path === '/lp' && to.query && to.query.lang) {
    return next()
  }

  const navBarMenu = document.querySelector('.navbar-menu')
  if (navBarMenu && navBarMenu.classList && !navBarMenu.classList.contains('d-none')) {
    navBarMenu.classList.add('d-none')
  }

  const submenuContainerFloating = document.querySelector('.submenu-container-floating');
  if (submenuContainerFloating) {
    submenuContainerFloating.classList.add('d-none');
  }

  const tooltips = document.querySelectorAll('.tooltip');
  if (tooltips) {
    tooltips.forEach(tooltip => {
      tooltip.remove();
    });
  }

  const modals = document.querySelectorAll('.modal.show');

  if (modals.length > 0) {
    modals.forEach(modal => {
      // Bootstrap Modal backdrop
      const backdrop = document.querySelector('.modal-backdrop');

      // Check if a backdrop element exists
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }

      // Remove the modal element from the DOM
      modal.parentNode.removeChild(modal);
    });

    const body = document.querySelector('body');
    if (body) {
      body.classList.remove('modal-open')
      body.style = ''
    }
  }

  next();
});

let initialPixelPageViewHandled = false

const canonicalOrigin = 'https://dash.gstocky.com'

function updateCanonicalUrl(route) {
  const canonicalPath = route.path.replace(/\/+$/, '') || '/'
  let canonicalLink = document.querySelector('link[rel="canonical"]')

  if (!canonicalLink) {
    canonicalLink = document.createElement('link')
    canonicalLink.setAttribute('rel', 'canonical')
    document.head.appendChild(canonicalLink)
  }

  canonicalLink.setAttribute('href', `${canonicalOrigin}${canonicalPath}`)
}

router.afterEach((to) => {
  // Keep the canonical in sync during client-side navigation. Query strings
  // contain plan, billing, offer, referral, or auth data and are deliberately
  // excluded so all variants consolidate on the route itself.
  updateCanonicalUrl(to)

  // The base Pixel code tracks the first page load in public/index.html.
  if (!initialPixelPageViewHandled) {
    initialPixelPageViewHandled = true
    return
  }

  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
})


export default router
